import { CustomDtcBagButton } from "@brandclub/common-ui";
import BagDrawer from "./BagDrawer";
import { useQuery } from "@tanstack/react-query";
import { appThemeQueryOptions } from "@/api/cache/appThemeQueryOptions";
import { useCartCount } from "@/api/cache/cartQueryOptions";

const BCBagButton = ({ mobile }: { mobile?: boolean }) => {
  const { data: cartCount } = useCartCount();
  const { data: styleData } = useQuery(appThemeQueryOptions());

  const handleClick = () => {
    BagDrawer.show();
  };

  return (
    <>
      <CustomDtcBagButton
        handleClick={handleClick}
        cartCount={cartCount}
        styleData={styleData}
        mobile={mobile}
      />
      <BagDrawer />
    </>
  );
};

export default BCBagButton;
